export enum CashPayoutType {
  NotApplicable = 'NotApplicable',
  OpenPaymentCountry = 'OpenPaymentCountry',
  OpenPaymentCorrespondent = 'OpenPaymentCorrespondent',
  LocationSpecific = 'LocationSpecific',
  Other = 'Other',
}



// WEBPACK FOOTER //
// ./src/model/types/cash-payout-type.ts